import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ token, children, loadingSession }) {
  if (loadingSession) return <div className="loading">Loading session...</div>;
  if (!token) return <Navigate to="/login" replace />;
  return children;
}
